import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { CustomerCapacityPlanReport } from "../components";


class CustomerCapacityPlanReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "report",
            title: "Customer Capacity Plan Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Customer capacity plan report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <CustomerCapacityPlanReport />
            </Base>
        );
    }
}

export default CustomerCapacityPlanReportContainer;
